import { HttpClient } from '@angular/common/http';
import { Injectable, signal, WritableSignal } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AchievementAlert, AchievementConfig, Signal } from '../dto';
import { AbstractService } from './abstractservice';
import { ApplicationService } from './application.service';
import { AchievementToast } from './signal.service';

@Injectable({
    providedIn: 'root'
})
export class AchievementService extends AbstractService {

    // Not read or written anywhere else in the app (verified by grep) - kept as a signal for
    // consistency with this service's sibling state fields rather than removed, since deciding
    // whether it's dead code the team meant to wire up later is outside a signals-conversion pass.
    public achievementDetails: WritableSignal<AchievementConfig[]> = signal<AchievementConfig[]>([]);

    constructor(private http: HttpClient, private coreAppService: ApplicationService) {
        super(coreAppService.authService, coreAppService.featureFlagService);
        coreAppService.userService.activeUser$.subscribe(u => {
            if (u && u.Username && this.authService.isAuthenticated()) {
                coreAppService.notificationService.initializeConnection();
            }
        });

        coreAppService.notificationService.latestNotificationSignal.subscribe(this.receiveNotification.bind(this));
    }

    public getAchievements(userName: string): Observable<number[]> {
        return this.http.get<number[]>(`${environment.apiUrl}/achievement/user/${userName}`, this.httpOptionsAuthJson());
    }

    public getAchievementConfig(achievementType: number): Observable<AchievementConfig> {
        // TODO caching
        return this.http.get<AchievementConfig>(`${environment.apiUrl}/achievement/${achievementType}`, this.httpOptionsAuthJson()).pipe(map(ach => new AchievementConfig(ach)));
    }

    /**
     * Handler function for notifications from the NotificationService (sent asynchronously via SignalR)
     * This impl ignores all non NewMessageAlert notifications
     */
    private receiveNotification(value: Signal): void {
        if ((<AchievementAlert>value)?.Achievement) {
            const achievement = new AchievementConfig((<AchievementAlert>value).Achievement);

            //constructor(body: string, title: string, visibleDuration: number | null)
            var toast = new AchievementToast(achievement.Description, achievement.Name, achievement.ImagePath, null);
            if (toast.visibleDuration === 0) return;
            this.coreAppService.notificationService.addToast(toast);
        }
    }
}
